import { addons } from "../../domain/addon";

const priceFor = ({ addon, cart }) =>
  addon.isVipAddon && cart.purchaseSubscription ? 0 : addon.rawPrice;

const excludedBy = (addon, selectedNames) =>
  (addon.isSoftShellCase && selectedNames.has(addons.HARD_SHELL_CASE)) ||
  (addon.isHardShellCase && selectedNames.has(addons.SOFT_SHELL_CASE));

const placementFor = ({ addon, cartProduct, cart, selectedNames }) => {
  const selected = cartProduct.addons.find((a) => a.name === addon.name);

  return selected
    ? {
        added: addon.clone({
          addon_price: priceFor({ addon: selected, cart }),
        }),
      }
    : addon.isVipAddon && cart.purchaseSubscription
    ? { added: addon.clone({ addon_price: 0 }) }
    : excludedBy(addon, selectedNames)
    ? {}
    : { unadded: addon };
};

export const cartProductAddons = ({ availableAddons, cartProduct, cart }) => {
  const selectedNames = new Set(cartProduct.addons.map((a) => a.name));
  const placements = Object.values(availableAddons ?? {}).map((addon) =>
    placementFor({ addon, cartProduct, cart, selectedNames }),
  );

  return {
    addedAddons: placements.flatMap(({ added }) => (added ? [added] : [])),
    unaddedAddons: placements.flatMap(({ unadded }) =>
      unadded ? [unadded] : [],
    ),
  };
};

export default cartProductAddons;
